import React from 'react';
import { personalPhotos } from '../data/personal';
import '../styles/personal-photos.css';

export default function Portrait() {
  const photo = personalPhotos.blazer;
  return <div className="portrait-avatar"><picture>
    <source type="image/webp" srcSet={photo.srcSet} sizes="(max-width: 600px) 180px, 300px"/>
    <img src={photo.fallback} alt={photo.alt} width={480} height={480} loading="eager" fetchPriority="high" decoding="async"/>
  </picture></div>;
}
